import {createContext, useContext} from 'react'

export const DatatableContext = createContext({})

export const useDatatableContext = () => useContext(DatatableContext)
